@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.value {
  @include cxy.font-size('text-s', var(--cxy-fontWeight-semiBold));
  color: var(--cxy-color-text-default-body);
  margin-block: 0 var(--cxy-spacing-xxxsm);

  @include cxy.screen-size('desktop') {
    margin-block-end: var(--cxy-spacing-xxsm);
  }
}

.progressWrapper {
  width: 100%;

  &[data-disabled='true'] {
    .value {
      color: var(--cxy-color-surface-primary-default-subtle-hover);
    }

    .progressRoot,
    .progressIndicator {
      background-color: var(--cxy-color-surface-primary-default-subtle-hover);
    }
  }
}

.progressRoot {
  position: relative;
  overflow: hidden;
  background-color: var(--cxy-color-surface-default);
  border-radius: 40px;
  width: 100%;
  max-width: 64px;
  height: 4px;

  /* Fix overflow clipping in Safari */
  /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
  transform: translateZ(0);

  @include cxy.screen-size('desktop') {
    max-width: 100px;
  }
}

.progressIndicator {
  background-color: var(--cxy-color-brand);
  width: 100%;
  height: 100%;
  transition: transform 660ms cubic-bezier(0.65, 0, 0.35, 1);
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .progressRoot {
    background-color: var(--cxy-color-container-track);
  }
}
